import React from "react";
import {Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
export default React.createClass({
  displayName: "sdk-doc-code-blocks",
  activeBlock: "",
  getInitialState: function() {
    // set a default
    return {language: null}
  },

  setActiveBlock: function(e) {
    var language = e.target.id.slice(0, -1);
    this.setState({language: language})
    e.preventDefault();
  },


  clickHandler(e) {
    // prevent button from passing through
    e.preventDefault();
    var el = e.target.parentNode.parentNode.childNodes[0]
    // var el = document.getElementsByClassName("feedback")[0];
    // add this class
    el.className += " displayCode"
    // wait 5 seconds and remove class
    setTimeout(function () {
        el.classList.remove("displayCode");
    }, 2000);
  },

  // Allow the label on the tab to be different from the language that is passed to highlight.js
  transformLabelToLanguage: function(label){
    let transforms = {
      "curl": "bash"
    };
    if (transforms.hasOwnProperty(label)){
      return transforms[label];
    }
    return label;
  },

  render: function() {
    var codeBlocks = [];
    Object.keys(this.props).forEach(function (property, index) {
      if (property !== "id") {
        if (!this.state.language) {
          this.state.language = property
        }
        if (this.state.language === property) {
          var classLabel = "active unlist";
          this.activeBlock = this.props[property]
        } else {
          var classLabel = "passive unlist";
        }
        codeBlocks.push(<li className={classLabel} id={property} key={index}>
          <a id={property+"a"} data-toggle="tab" style={{cursor: "pointer"}} onClick={this.setActiveBlock}>{property}</a>
        </li>)
      }
    }.bind(this))
    var highlightClassNames = `code-block ${this.transformLabelToLanguage(this.state.language)}`;
    var copyClass = "copy-button ";
    if (this.state.language === "swift"){
      copyClass += "copy-ios"
    }
    else if (this.state.language === "objC") {
      copyClass += "copy-ios"
    }
    else if(this.state.language === "js" || this.state.language === "curl" || this.state.language === "json") {
      copyClass += "copy-js"
    }
    return (
      <div className="code-switch">
        <ul key={99} className="nav nav-tab">
          {codeBlocks}
        </ul>
        <Highlight className={highlightClassNames}>
          <div className="code-only">{this.activeBlock}</div>
          <div className="copy-btn-group">
            <span className="feedback">Copied!</span>
            <button className={copyClass}  data-clipboard-text=".code-only" onClick={this.clickHandler}>
              <Glyphicon glyph="copy" />
            </button>
          </div>
        </Highlight>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./src/js/utilities/sdk-doc-code-blocks.jsx